// src/theme/ThemeContext.tsx
import React, { createContext, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectDarkMode } from '../redux/slices/playerSlice';

const ThemeContext = createContext({ isDarkMode: false });

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const isDarkMode = useSelector(selectDarkMode) ?? false;

    useEffect(() => {
        document.documentElement.classList.toggle('dark', isDarkMode);
    }, [isDarkMode]);

    return (
        <ThemeContext.Provider value={{ isDarkMode }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);